import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import Routes from './utils/routes.js';

function App() {
  return (
      
        <div className="App">
        <BrowserRouter>
        <Switch>
          {Routes.map((item) => (
            <Route key={item.path} path={item.path} component={item.component}/>
          ))}
        </Switch>
      </BrowserRouter>
        </div>
      
  );
}

export default App;
